import { http, setAccess, setRefresh, getAccess } from '@/api/http';
import { ensureCurrentUser, clearCachedCurrentUser } from '@/api/user';
import { moduleFromPath, canAccessModule, canAccessPath, getDefaultPathForUser, isAdmin } from '@/access/armAccess';

export async function login({ iin, password }) {
    try {
        const { data } = await http.post('users/login/', { iin, password });
        if (data?.access) setAccess(data.access);
        if (data?.refresh) setRefresh(data.refresh);
        // Cache current user (position/arm_roles) for UI gating.
        await ensureCurrentUser({ force: true });
        return data;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Backend login failed', e);
        throw e;
    }
}

export async function refreshToken(refresh) {
    const { data } = await http.post('users/token/refresh/', { refresh });
    if (data?.access) setAccess(data.access);
    return data;
}

export function logout() {
    setAccess('');
    setRefresh('');
    clearCachedCurrentUser();
}

export default async function auth(to, from, next) {
    try {
        // Публичные роуты (например, kiosk-режим МПО) — без проверки токена.
        if (to.meta?.public) return next();

        const token = getAccess();
        if (!token && to.path !== '/login') {
            return next({ path: '/login', query: { redirect: to.fullPath } });
        }

        if (token && to.path !== '/login') {
            const user = await ensureCurrentUser();

            // Маршруты с meta.adminOnly доступны только админу (RBAC ADMIN,
            // либо is_superuser / is_staff для обратной совместимости).
            if (to.meta?.adminOnly) {
                if (!isAdmin(user)) {
                    const safePath = getDefaultPathForUser(user);
                    if (safePath && safePath !== to.path) {
                        return next({ path: safePath });
                    }
                }
            }

            // Path-level gating (more strict than module-level).
            if (!canAccessPath(user, to.path)) {
                const safePath = getDefaultPathForUser(user);
                if (safePath && safePath !== to.path) {
                    return next({ path: safePath });
                }
            }

            const moduleKey = moduleFromPath(to.path);
            if (moduleKey && !canAccessModule(user, moduleKey)) {
                const safePath = getDefaultPathForUser(user);
                if (safePath && safePath !== to.path) {
                    return next({ path: safePath });
                }
            }
        }
        return next();
    } catch {
        return next({ path: '/login', query: { redirect: to.fullPath } });
    }
}